import { render } from "./PreviouslyPublishedBooks.vue?vue&type=template&id=c9c7202c"
import script from "./PreviouslyPublishedBooks.vue?vue&type=script&lang=js"
export * from "./PreviouslyPublishedBooks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__